export const FETCH_CART_LIST = 'FETCH_CART_LIST';
export const FETCH_CART_LIST_SUCCESS = 'FETCH_CART_LIST_SUCCESS';
export const FETCH_CART_LIST_FAILURE = 'FETCH_CART_LIST_FAILURE';
export const GET_CARTS = 'GET_CARTS';